import React from 'react';

import { Folder } from '@qality/common-components/src/atoms/Folder';
import { SkeletonItem } from '@qality/common-components/src/atoms/SkeletonItem';
import { Folder as FolderModel } from '@qality/common-model';

import { useTestCaseRepositoryFoldersContext } from '../TestCaseRepositoryFoldersProvider/TestCaseRepositoryFoldersProvider';
import {
  ContainerStyled,
  SkeletonItemWrapperStyled,
} from './TestCaseRepositoryFoldersTree.styled';

const NUMBER_OF_SKELETON_ITEMS = 10;

export function TestCaseRepositoryFoldersTree(): JSX.Element {
  const {
    isLoading,
    folders,
    currentFolder,
    openFolder,
    expandFolder,
    collapseFolder,
    isFolderExpanded,
    getSubfolders,
  } = useTestCaseRepositoryFoldersContext();

  if (isLoading) {
    return (
      <ContainerStyled>
        {Array.from({ length: NUMBER_OF_SKELETON_ITEMS }).map((_, index) => {
          return (
            <SkeletonItemWrapperStyled key={index}>
              <SkeletonItem width='100%' hasIcon />
            </SkeletonItemWrapperStyled>
          );
        })}
      </ContainerStyled>
    );
  }

  const handleClick = async (folder: FolderModel) => {
    await openFolder(folder);
    await expandFolder(folder);
  };

  const handleIsHighlighted = (folder: FolderModel) => {
    const isCurrentFolder = folder.id === currentFolder?.id;
    return {
      isFolderHighlighted: isCurrentFolder,
      isWholeSubtreeHighlighted: isCurrentFolder,
    };
  };

  return (
    <ContainerStyled>
      {folders
        .filter((folder) => folder.parentId === null)
        .map((folder) => {
          return (
            <Folder
              key={folder.id}
              folder={folder}
              onClick={handleClick}
              onExpand={expandFolder}
              onCollapse={collapseFolder}
              isHighlighted={handleIsHighlighted}
              isExpanded={isFolderExpanded}
              getSubfolders={getSubfolders}
              isExpandable={() => true}
            />
          );
        })}
    </ContainerStyled>
  );
}
